import { render, staticRenderFns } from "./StaffRecords.vue?vue&type=template&id=2eb1b3dc&scoped=true"
import script from "./StaffRecords.vue?vue&type=script&lang=js"
export * from "./StaffRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb1b3dc",
  null
  
)

export default component.exports